<!--
 * @Author: xing.huang
 * @Date: 2021-02-20 10:24:10
 * @LastEditTime: 2021-03-01 17:51:12
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\customPrint\PreviewDialog.vue
 * @
-->
<template>
    <el-dialog  title="查看模板"  :visible.sync="isShowDialog" :width="maxW+100+'px'" center :close-on-click-modal="false" @close="cancelViweDialog">
        <div class="edit-content" :style="{width:maxW+'px',height:maxH+'px',}" >
            <div class="list-warp" :style="{width:maxW+'px',height:maxH+'px',}" :list="columnList" >
                
                <div :class="element.propertyType==0?['item','item-text']:['item']" v-for="(element,index) in columnList" :key="index" :style="{left:element.x+'px',top:element.y+'px'}" >
                    <span  v-if="element.propertyType==0" :style="{fontSize:element.fieldSize+'px'}">{{ element.text||element.propertyName }}</span>
                    <span  v-if="element.propertyType==1" :style="{fontSize:element.fieldSize+'px'}">XXXXX</span>
                    <div v-if="element.propertyType==2">
                        <QrcodeVue :value="element.propertyName" :size="element.fieldSize" level="H" ></QrcodeVue>
                    </div>
                </div>
            </div>
        </div>
        <div style="text-align:center">
            <el-button  @click="cancelViweDialog">取 消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import QrcodeVue from 'qrcode.vue';


export default {
    name: 'PreviewDialog',
    components:{QrcodeVue},
	props: {
        isShow: Boolean,
        columnList:Array,
        maxW:Number,
        maxH:Number,
	},
	data() {
		return {
            isShowDialog: false,
            W:true,
		}
	},
	//el和data尚未初始化
	beforeCreate: function(){},
	//data初始化完成
	created: function(){
		
	},
	//el初始化完成
	beforeMount: function(){},
	//完成挂载
	async mounted(){
       
	},
	
	methods: {
       

		initData(){

        },
        cancelViweDialog(){
            this.$parent.isShow = false
        },
	},
	watch: {
		"isShow": function (newVal, oldVal) {
			this.isShowDialog = this.isShow;
		},
	},
}
</script>
<style scoped>
.list-warp{
   
   position: relative;
   background: #fff;
   box-sizing: border-box;
}
.list-warp .item{
    position: absolute;
}
.item-text span{
    position: relative;
    top:0px;
    right: -10px;
}
</style>



// WEBPACK FOOTER //
// src/views/customPrint/PreviewDialog.vue